<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';
import { vMove, vInput, useCover } from './index';
type Pos = {
  left: number;
  top: number;
  center?: boolean;
  initHeight?: number;
  left2right?: boolean;
};
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="1196.282" height="1685.997" viewBox="0 0 1196.282 1685.997">
  <g transform="translate(1.001 0.998)">
    <path d="M16070.067-10112.748H15759.5V-10664H16238l-167.933,551.246Zm62.218,0h-6.273l174.935-574.244H15759.5V-10693h549.554l-1.179,3.874Z" transform="translate(-15760 11797.248)" fill="var(--theme-color-1)" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    <path d="M17033.781-9767.5h-549.559l1.178-3.879,159.367-523.124h6.273L16492.33-9773.5h541.449l0,6.008Zm0-29.007h-478.5l151.709-498h326.793Z" transform="translate(-15839 10294)" fill="var(--theme-color-1)" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
  </g>
</svg>
`;

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: calc(100% + 0px);
  height: calc(100% + 0px);
  position: absolute;
  left: 0px;
  top: 0px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  text-align: right;
}
.project-name,
.time {
  font-size: 63px;
  font-weight: 600;
  color: #404040;
}

.project-name {
  width: 950px;
}
.time {
  font-size: 36px;
  min-width: 250px;
  max-width: 690px;
  color: #484848;
}
.enterprise-name {
  font-size: 36px;
  font-weight: 600;
  max-width: 600px;
  min-width: 450px;
  color: #484848;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
